import {useMemo} from 'react';

import {Project} from '../../../../../generated/graphql';
import {useRunSelectorQuery} from '../../../../../state/graphql/runSelectorQuery';

export const useWorkspaceConfigKeys = (
  projectInternalId: string | undefined
) => {
  const runSelectorQuery = useRunSelectorQuery(projectInternalId);

  return useMemo(() => {
    if (
      !runSelectorQuery.initialLoading &&
      !runSelectorQuery.loading &&
      runSelectorQuery.project
    ) {
      return parseProjectConfigKeys(runSelectorQuery.project);
    }
    return [];
  }, [
    runSelectorQuery.loading,
    runSelectorQuery.project,
    runSelectorQuery.initialLoading,
  ]);
};

export function parseProjectConfigKeys(project: Project) {
  return project.fields.edges
    .filter(edge => edge.node.path.startsWith('config.'))
    .map(edge => edge.node.path)
    .filter((value, index, self) => self.indexOf(value) === index);
}
